import { render, staticRenderFns } from "./PaymentDocumentsPage.vue?vue&type=template&id=f781c212&scoped=true"
import script from "./PaymentDocumentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f781c212",
  null
  
)

export default component.exports